module.exports = __webpack_public_path__ + "img/gym_thumbnail.9283e1bf.jpg";